<template>
  <div style="padding:20px;">
    <el-row :gutter="20">
      <el-row style="margin-bottom: 10px;">
        <el-button type="primary" size="small" @click="getList()">
          查询
        </el-button>
        <el-button type="primary" size="small" @click="addActivity()">增加活动</el-button>
      </el-row>
      <el-table :data="listData" style="width: 100%" border v-loading="listLoading">
        <el-table-column prop="id" label="活动ID" width="90"></el-table-column>
        <el-table-column prop="title" label="标题" width="250"></el-table-column>
        <el-table-column prop="coupon_title" label="优惠券标题" width="250"></el-table-column>
        <el-table-column label="活动时间" width="180">
          <template slot-scope="{row}">{{ row.start_at }} ~ {{ row.end_at }}</template>
        </el-table-column>
        <el-table-column label="抢券时间" width="180">
          <template slot-scope="{row}">{{ row.coupon_start_at }} ~ {{ row.coupon_end_at }}</template>
        </el-table-column>
        <el-table-column label="下次抢券时间" width="180">
          <template slot-scope="{row}">{{ row.coupon_next_at }} ~ {{ row.coupon_next_end_at }}</template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="{row}">
            <!-- <el-button type="primary" size="small" @click="copy(row.url)" class="copy">复制链接</el-button> -->
            <copyLink :url="row.url" buttonName="复制链接"></copyLink>
            <el-button type="primary" size="small" @click="updateAssist(row.id)">活动信息</el-button>
            <el-button type="primary" size="small" @click="pageElementConfig(row.id)">页面配置</el-button>
            <el-button type="primary" size="small" @click="pageIdConfig(row.id)">内容配置</el-button>
            <template v-if="row.status == 1">
              <el-button type="danger" size="small" @click="updateOnline(row.id, 'offline')">下架</el-button>
            </template>
            <template v-else>
              <el-button type="success" size="small" @click="updateOnline(row.id, 'online')">上架</el-button>
            </template>

            <template v-if="row.status == 0">
              <el-button type="danger" size="small" @click="deleteActivity(row.id)">删除</el-button>
            </template>
          </template>
        </el-table-column>
      </el-table>

      <div style="margin-top:10px">
        <el-pagination background @current-change="getList" :current-page.sync="query.page"
                       :page-size="query.limit"
                       layout="total, prev, pager, next, jumper" :total="listTotal">
        </el-pagination>
      </div>
    </el-row>
  </div>
</template>

<script>
import copyLink from "@/components/copyLink.vue";
import Clipboard from 'clipboard';
import {
  getList, updateOnline, deleteActivityInfo
} from "@/api/activityCustom";

export default {
  components: { copyLink },
  data:function () {
    return {
      listData:[],
      listLoading:false,
      listTotal:0,
      query:{
        limit:20,
        page:1
      }
    }
  },
  created: function() {
    this.getList();
  },
  methods: {
    getList(){
      this.listLoading = true;
      getList(this.query).then(response => {
        this.listData = response.data.list
        this.listLoading = false;
      });
    },
    pageElementConfig(id){
      this.$router.push({
        path: "/activity/custom/pageElementConfig",
        query: {id:id}
      });
    },
    pageIdConfig(id){
      this.$router.push({
        path: "/activity/custom/pageIdConfig",
        query: {id:id}
      });
    },
    updateAssist(id){
      this.$router.push({
        path: "/activity/custom/info",
        query: {type:'update', id:id}
      });
    },
    addActivity(){
      this.$router.push({
        path: "/activity/custom/info",
        query: {type:'create'}
      });
    },
    updateOnline(id,type){
      this.listLoading = true;
      updateOnline({id,type}).then(response => {
        this.listLoading = false;
        if(response.code == 1){
          this.getList();
          this.$message({
            showClose: true,
            duration: 6000,
            message: '修改成功',
            type: 'success'
          });
        }
      });
    },
    deleteActivity(id){
      this.$confirm('此操作将删除活动信息，是否确认操作？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.listLoading = true;
        deleteActivityInfo({id}).then(response => {
          this.listLoading = false;
          if(response.code == 1){
            this.getList();
            this.$message({
              showClose: true,
              duration: 6000,
              message: '删除成功',
              type: 'success'
            });
          }
        });
      }).catch(() => {

      });
    },
    copy(url){
      let clipboard = new Clipboard('.copy', {
        text: function () {
          return url
        }
      })
      clipboard.on('success', e => {
        this.$message({
          showClose: true,
          duration: 3000,
          message: '复制成功',
          type: 'success'
        })
        // 释放内存
        clipboard.destroy()
      })
    }
  },
}
</script>
<style>
.el-button{
  margin-left: 10px;
  margin-bottom: 10px;
}
</style>